export default "__VITE_ASSET__edc58d1a__"